// create existence flag for each piece of store data
// makes it easier to debug timing issues in App.tsx

export const isCatalogSelected = state => !!state.catalog;
export const getCatalog = state => state.catalog;

export const isCatalogDataLoaded = state => !!state.catalogData;
export const getCatalogData = state => state.catalogData;
